import BasePropertyView from 'BasePropertyView.js';
import sequenceService from 'SequenceService.js';
import DesignerModel from 'DesignerModel.js';
import { Model } from 'backbone';

import formulaModal from '../../common-views/MainFormulaModalView.js';
import selectFieldModal from 'common-views/SelectFieldModalView';
import nameTemplate from 'properties/main/instance-name.ejs';
import listService from 'ListService';

class MainInstanceNameView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[name=instanceName]' : 'updateRadioAttributes',
            'change input[id=TextOrNumber]'   : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #Special'                 : 'updateSpecialAttribute',
            'click #Formula'              : 'showFormulaModal',
            'click #ValueOfAFieldButton'  : 'showValueFieldModal'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    showFormulaModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        const attributes = {factoryKey: factoryKey};

        var sfModal = new formulaModal({model: new Model(), config: {selected: ''}});
        sfModal.render().then((selectedField)=>{
            //TODO:   Get the selected field, and set value on the modal
            //  Also change the creation of the modal passing the appropiated value on the config
        }).catch(err => console.log(err));
    }

    showValueFieldModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';

        var sfModal = new selectFieldModal({model: new Model()});
        sfModal.render().then((selectedField)=>{
            this.model.set('ValueOfAFieldId', selectedField.id, {silent:true});
            this.model.set('ValueOfAField', selectedField.name);
            
        });
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
        this.resetFields();
        $('#'+propName).attr('disabled', false);
        $('#'+propName).attr('readOnly', false);
        $("input[name=instanceName][value="+ propName+"]").prop('checked', true);
    }

    updateSpecialAttribute(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    resetFields() {
        $('#TextOrNumber').attr('disabled', true);
        $('#TextOrNumber').attr('readOnly', true);
        $('#ValueOfAField').attr('disabled', true);
        $('#ValueOfAField').attr('readOnly', true);
        $('#ValueOfAFieldButton').attr('disabled', true);
        $('#Special').attr('disabled', true);
        $('#Special').attr('readOnly', true);
        $('#Formula').attr('disabled', true);
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );

        this.resetFields();
        $('#'+propVal).attr('disabled', false);
        $('#'+propVal).attr('readOnly', false);
        if (propVal === 'ValueOfAField') {
            $('#ValueOfAFieldButton').attr('disabled', false);
            $('#ValueOfAField').attr('readOnly', true);
        }

        $("input[name="+propName+"][value=" + propVal + "]").prop('checked', true);
    }

    render() {
        this.$el.empty();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var option=  this.model.get('instanceName');
        if (this.model.get('instanceName')) {
            $("input[name=instanceName][value=" + option + "]").prop('checked', true);
            $('#'+option).attr('disabled', false);
            $('#'+option).attr('readOnly', false);
            if (option === 'ValueOfAField') {
                $('#ValueOfAFieldButton').attr('disabled', false);
                $('#ValueOfAField').attr('readOnly', true);
            }
        }

        if(this.model.get('Special')) {
            $('#Special').find('option[value='+this.model.get('Special')+']').attr('selected', true);
        }

        this.delegateEvents();

        return this;
    }

}

export default MainInstanceNameView;
